import React from 'react';
import {observer} from 'mobx-react';
import {action} from 'mobx';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';
import {injectIntl} from 'react-intl';
import {
    FormGroup, FormControl, ControlLabel,
    Form, Row, Col, Checkbox, Button, ButtonToolbar, Alert
} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';

import AttachmentsForm from '../common_components/attachments/AttachmentsForm';
import {BMC_BLOCKS} from "../common_components/bmc/bmc_constants";
import {
    getBlockCardsAsHTMLOptions, getBlockCardsFromHTMLSelectedOptions,
    getCardsAsHTMLOptions
} from "./common/CardsSelectOptionsHelpers";
import ButtonWithConfirmation from "../common_components/ButtonWithConfirmation";
import AITextEditor from '../AITextEditor';

@observer
class CostStructureForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: "",
            name: "",
            blockType: "no_block_type",
            cardSelects: [],
            totalCost: 0,
            pricingType: "no_pricing_type",
            description: "",
            attach_url: undefined,
            isEdition: false,
        };

        this.canDeleteCard = props.blockStore.rootStore.authorizationStore.canDeleteCard(props.blockStore.editingCard);

        this.renderSaveOrUpdateButton = this.renderSaveOrUpdateButton.bind(this);
        this.renderCardsSelectOptions = this.renderCardsSelectOptions.bind(this);
        this.renderCardSelect = this.renderCardSelect.bind(this);

        this.handleLabelChange = this.handleLabelChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleBlockTypeChange = this.handleBlockTypeChange.bind(this);
        this.handleCardsSelectChange = this.handleCardsSelectChange.bind(this);
        this.handleTotalCostChange = this.handleTotalCostChange.bind(this);
        this.handlePricingTypeChange = this.handlePricingTypeChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    render() {
        return (
            <div>
                {this.renderForm()}
            </div>
        );
    }

    renderForm() {
        const {blockStore, intl} = this.props;

        let cancelBtn;

        if (this.props.hideCancelBtn == null) {
            cancelBtn = <Button bsStyle="default" onClick={this.handleCancel}>
                {intl.formatMessage({id: "cancel"})}
            </Button>;
        } else {
            cancelBtn = <div></div>;
        }


        const labelValue = this.state.label.trim() ?
            intl.formatMessage({
                id: this.state.label,
                defaultMessage: " "
            }) : "";

        return (
            <div>

                {this.state.isEdition && (

                    <FormGroup
                        controlId="LabelCSId"
                        validationState={this.validateLabel()}>
                        <Row>
                            <Col xs={12} sm={2}>
                                <ControlLabel> {intl.formatMessage({id: "station"})} </ControlLabel>
                            </Col>
                            <Col xs={12} sm={10}>
                                <FormControl
                                    type="text"
                                    value={labelValue}
                                    placeholder=""
                                    onChange={this.handleLabelChange}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                )}


                <FormGroup
                    controlId="NameCSId"
                    validationState={this.validateName()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel> {intl.formatMessage({id: "name"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl
                                type="text"
                                value={this.state.name}
                                placeholder=""
                                onChange={this.handleNameChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="DescriptionCSId" validationState={this.validateDescription()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel>{intl.formatMessage({id: "description"})}</ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <AITextEditor
                                value={this.state.description}
                                onChange={(value) => this.setState({description: value})}
                                context="El texto con el que estás trabajando es sobre la descripción de estructura de costos en un modelo de negocio Canvas. La estructura de costos describe los costos más importantes incurridos al operar bajo un modelo de negocio particular. Incluye costos fijos, variables, economías de escala y economías de alcance."
                                rows={4}
                                placeholder=""
                            />
                        </Col>
                    </Row>
                </FormGroup>


                <Row>
                    <Col xs={8}>
                        {this.renderCardSelect()}
                    </Col>

                    <Col xs={4}>
                        <FormGroup controlId="BlockTypeCSId">

                            <ControlLabel>{intl.formatMessage({id: "type"})} </ControlLabel>

                            <FormControl componentClass="select" placeholder="select"
                                         onChange={this.handleBlockTypeChange}
                                         value={this.state.blockType}
                            >
                                <option value="no_block_type">{intl.formatMessage({id: "select"})}</option>

                                <option
                                    value={BMC_BLOCKS.KEY_RESOURCES}> {intl.formatMessage({id: BMC_BLOCKS.KEY_RESOURCES})}</option>
                                <option
                                    value={BMC_BLOCKS.KEY_ACTIVITIES}> {intl.formatMessage({id: BMC_BLOCKS.KEY_ACTIVITIES})}</option>
                                <option
                                    value={BMC_BLOCKS.KEY_PARTNERS}> {intl.formatMessage({id: BMC_BLOCKS.KEY_PARTNERS})}</option>
                            </FormControl>

                        </FormGroup>
                    </Col>
                </Row>


                <Row>
                    <Col xs={8}>
                        <FormGroup
                            controlId="TotalCostCSId"
                            validationState={this.validateTotalCost()}>
                            <ControlLabel> {intl.formatMessage({id: "total-cost"})} </ControlLabel>
                            <FormControl
                                type="number"
                                value={this.state.totalCost}
                                step="1"
                                placeholder=""
                                onChange={this.handleTotalCostChange}
                            />

                        </FormGroup>
                    </Col>

                    <Col xs={4}>
                        <FormGroup controlId="PricingTypeCSId">
                            <ControlLabel>{intl.formatMessage({id: "pricing-type"})}</ControlLabel>
                            <FormControl componentClass="select"
                                         onChange={this.handlePricingTypeChange}
                                         value={this.state.pricingType}
                            >
                                <option value="no_pricing_type">{intl.formatMessage({id: "select"})}</option>
                                <option value="per_unit"> {intl.formatMessage({id: "per-unit"})}</option>
                                <option value="one_month"> {intl.formatMessage({id: "1-month"})}</option>
                                <option value="three_months"> {intl.formatMessage({id: "3-months"})}</option>
                                <option value="one_year"> {intl.formatMessage({id: "1-year"})}</option>
                            </FormControl>
                        </FormGroup>
                    </Col>

                </Row>


                <AttachmentsForm attachable={blockStore.editingCard}/>

                <br/>

                <ButtonToolbar className="pull-right">
                    {this.renderSaveOrUpdateButton()}

                    {this.state.isEdition && this.canDeleteCard && (
                        <ButtonWithConfirmation dropdownClassname="bmc-card-delete-button"
                                                confirmationMessage={intl.formatMessage({id: "delete_confirmation_msg"})}
                                                option1Label={intl.formatMessage({id: "delete_confirmation_no"})}
                                                option2Label={intl.formatMessage({id: "delete_confirmation_yes"})}
                                                onOption2Select={this.handleDelete}
                                                dropup>
                            {intl.formatMessage({id: "delete"})}
                        </ButtonWithConfirmation>
                    )}

                    {cancelBtn}
                </ButtonToolbar>

                <div className="clearfix"/>

            </div>
        );
    }

    renderSaveOrUpdateButton() {

        if (this.state.isEdition) {
            return (
                <Button bsStyle="primary" onClick={this.handleUpdate}>
                    {this.props.intl.formatMessage({id: "save"})}
                </Button>
            )
        } else {
            const buttonMessage = this.props.blockStore.rootStore.stepByStepMode ? "save" : "add";

            return (
                <Button bsStyle="primary" onClick={this.handleSubmit}
                        disabled={!this.state.name && !this.state.description}>
                    {this.props.intl.formatMessage({id: buttonMessage})}
                </Button>
            )
        }


    }

    renderCardSelect() {
        //console.log('renderCardSelect cards', this.state.cardSelects)
        return (
            <FormGroup
                controlId="CardsCSId"
                validationState={this.validateCardSelect()}
            >

                <ControlLabel> {this.props.intl.formatMessage({id: "cards"})}  </ControlLabel>

                <Select
                    multi
                    onChange={this.handleCardsSelectChange}
                    value={getCardsAsHTMLOptions(this.state.cardSelects)}
                    placeholder=""
                    options={this.renderCardsSelectOptions()}
                />

            </FormGroup>
        );
    }

    renderCardsSelectOptions() {
        return getBlockCardsAsHTMLOptions(this.props.blockStore, this.state.blockType)
    }


    handleLabelChange(e) {
        //this.setState({label: e.target.value});
    }

    handleNameChange(e) {
        this.setState({name: e.target.value});
    }

    handleBlockTypeChange(e) {
        this.setState({blockType: e.target.value});
    }

    handleCardsSelectChange(value) {
        const cards = getBlockCardsFromHTMLSelectedOptions(this.props.blockStore, this.state.blockType, value);

        this.setState({cardSelects: cards});

    }

    handleTotalCostChange(e) {
        this.setState({totalCost: e.target.value});
    }

    handlePricingTypeChange(e) {
        this.setState({pricingType: e.target.value});
    }

    handleDescriptionChange(e) {
        this.setState({description: e.target.value});
    }


    validateLabel() {

    }

    validateName() {

    }

    validateBlockType() {

    }

    validateCardSelect() {

    }

    validateTotalCost() {

    }

    validatePricingType() {

    }

    validateDescription() {

    }

    @action
    handleSubmit() {
        const card = this.generateCardFromState();
        this.props.blockStore.addCard(card);
        this.props.blockStore.showBlockModal(false);

        this.resetForm();
    }


    @action
    handleCancel() {
        const {blockStore} = this.props;
        blockStore.hideBlockModal(true);

        this.resetForm();
    }

    @action
    handleUpdate() {
        this.generateCardFromState();

        const {blockStore} = this.props;

        if (blockStore.editingCard.persisted) {
            blockStore.editingCard.update();
            blockStore.showBlockModal(false);
        }
    }


    @action
    handleDelete() {
        this.props.blockStore.editingCard.destroy();
        this.props.blockStore.hideBlockModal(true);

    }


    generateCardFromState() {
        const {editingCard} = this.props.blockStore;

        editingCard.label = this.state.label;
        editingCard.name = this.state.name;
        editingCard.blockType = this.state.blockType;
        editingCard.cardSelects = this.state.cardSelects;
        editingCard.totalCost = this.state.totalCost;
        editingCard.pricingType = this.state.pricingType;
        editingCard.description = this.state.description;

        return editingCard;
    }

    resetForm() {
        this.setState({
            label: "",
            name: "",
            blockType: "no_block_type",
            cardSelects: [],
            totalCost: 0,
            pricingType: "no_pricing_type",
            description: "",
            attach_url: undefined,

            isEdition: false,

        });
    }


    componentDidMount() {
        this.initFields(this.props.blockStore.editingCard);
    }

    initFields(card) {
        //const card = this.props.blockStore.editingCard;

        this.setState({
            label: card.label,
            name: card.name,
            blockType: card.blockType,
            cardSelects: card.cardSelects,
            totalCost: card.totalCost,
            pricingType: card.pricingType,
            description: card.description,

            isEdition: card.persisted,

        });
    }


}

export default injectIntl(CostStructureForm);